import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import StarsBlue from '../../assets/stars_blue.png'
import StarsYellow from '../../assets/stars_yellow.png'
import { SessionContextStore } from '../../context/SessionContext'
import './MyDiscounts.scss'
import { Divider, Grid, useMediaQuery, TextField } from '@material-ui/core'
import NewFillButton from '../Core/NewFillButton'
import { SafetyScore } from './SafetyScore'
// import { FlightExperience } from './FlightExperience'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { useForm } from 'react-hook-form'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import CodeIcon from '@material-ui/icons/Code';
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import { awaitWithLoading } from '../../services/utils'
import discountsApi from '../../api/discounts.api'
import { SessionService } from '../../services/SessionService'
import { BlueGrayBox } from "../Core/BlueGrayBox";
import { useLocation, useHistory } from 'react-router-dom'

export const MyDiscounts = () => {
    const sessionContext = useContext(SessionContextStore)
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const [redeemWindowOpen, setRedeemWindowOpen] = React.useState(false)
    const {register, triggerValidation, getValues, errors, setValue} = useForm({mode: 'onChange'})
    const closeRedeemWindow = () => setRedeemWindowOpen(false)
    const openRedeemWindow = () => setRedeemWindowOpen(true)
    const location = useLocation()
    const history = useHistory()
    const query = new URLSearchParams(location.search);

    React.useEffect(() => {
        register('redeem_code')
        setTimeout(() => {
            if(query.has('code')) {
                if(SessionService.isLoggedIn())
                    openRedeemWindow()
                else {
                    EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Discount Code',
                        body: 'You must login in order to use the redeem code',
                        actionText: "Login",
                        onClose: (val) => val == 1 && history.push('/login') })  
                }
            }            
        }, 2000)
    }, [])

    const redeem = async () => {
        let valid = await triggerValidation()
        if(!valid) return

        closeRedeemWindow()

        let res = await awaitWithLoading(discountsApi.useRedemptionCode(getValues().redeem_code))
        
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.REDEEM_CODE_APPLIED)
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: 'Code verified',
                body: "Your code was redeemed successfully",
                actionText: "Enjoy your discount"
            })
        }
        else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
        

    }


    return ( <>
            <Grid alignItems={'center'} justify={isMobile ? 'center' : 'space-between'} container className="margin-top-basic space-between">
                <Grid item xs={12} md={9}>
                    <FlexView vAlignContent={'bottom'}>
                        <FlexView hAlignContent={isMobile ? 'center' : 'left'}>
                            <img className='stars' src={StarsYellow} />
                            {sessionContext.user.totalDiscount != 1 ? 
                                <FlexView className="text-promotion margin-left-small margin-right-small" hAlignContent={'center'} vAlignContent={'center'}>
                                    You have <span className="bolder black margin-left-6 margin-right-6">{(100 - sessionContext.user.totalDiscount * 100).toFixed(0)}% </span> off!
                                </FlexView>
                                 : 
                                <div className="text-promotion margin-left-small margin-right-small black bolder">
                                    Safer pilots pay less 
                                </div>
                            }
                            <img className='stars' src={StarsBlue} />
                        </FlexView>
                        { SessionService.isBroker() && <div className='margin-top-basic text-tiny '><BlueGrayBox>{sessionContext.user.email}</BlueGrayBox></div> }
                    </FlexView>
                </Grid>
                <Grid item xs={6} md={3}>
                    <NewFillButton disabled={!SessionService.isLoggedIn()} onClick={openRedeemWindow}>I have a discount code</NewFillButton>
                </Grid>
            </Grid>
            <Divider />
            <SafetyScore />
            {/* <Divider />
            <FlightExperience /> */}
            <SkywatchDialog
                open={redeemWindowOpen}
                closeDialog={closeRedeemWindow}
                maxWidth={'xs'}
                closeTitle={'My Discounts'}
                circleHeader={<ElevatedCircle><CodeIcon className="blue" /> </ElevatedCircle>}>
                <div className="text-title blue textcenter ">Discount code</div>
                <div className='text-body black textcenter margin-top-small margin-bottom-basic'>Please enter your redemption code</div>
                <TextField className="margin-bottom-basic" fullWidth variant='outlined' label='Redeem code' 
                    name="redeem_code" 
                    inputRef={register({required: true})}
                    defaultValue={query.get('code')}
                    error={!!errors.redeem_code} 
                    helperText={!!errors.redeem_code && 'Required'} />
                <NewFillButton onClick={redeem}>Redeem</NewFillButton>
            </SkywatchDialog>
        </>
    )
}